module.exports = __webpack_public_path__ + "img/linelink.78471c92.png";